module.exports = __webpack_public_path__ + "img/floor.1891256e.svg";